
import * as easy from "@/components/easy"; 
import Agreement from "./Agreement.vue"
import PrivacyPolicyAgreement from "./PrivacyPolicyAgreement.vue"

// 显示验证码dialog
export function showAgreement() {
    return easy.showDialog(Agreement, {}, {
        title: "",
        customStyle: { width: '100%', height: '100%' },
        defaultFooter: false
    })
}

export function privacyPolicy() {
    if(window.parent != window.self) {
        window.open('/#/agreement', '_blank')?.focus();
        return;
    }

    return easy.showDialog(PrivacyPolicyAgreement, {}, {
        title: "",
        customStyle: {width: '100%', height: '100%' },
        defaultFooter: false
    })
}
